import React from 'react'
import { connect } from 'react-redux'
import DiscsList from './DiscsList'

function MyDiscs({ user, discs }) {
  if (!user) {
    return <p className="discs-signin">Sign in to see your discs.</p>
  }
  return <DiscsList discs={discs} />
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  discs: state.discs.discs,
})

export default connect(mapStateToProps)(MyDiscs)
